'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["bodyClassName", "bodyElement", "className", "tagName"];
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ComponentWithBodyClass from '../utils/ComponentWithBodyClass';

/**
 * Standard page container, setting classes, context, etc.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIPage(props) {
  const {
      bodyClassName,
      bodyElement,
      className,
      tagName: TagName
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const renderedChildren = /*#__PURE__*/_jsx(TagName, Object.assign({}, rest, {
    className: classNames(className, 'private-page')
  }));
  if (bodyClassName) {
    return /*#__PURE__*/_jsx(ComponentWithBodyClass, {
      bodyClassName: bodyClassName,
      bodyElement: bodyElement,
      children: renderedChildren
    });
  }
  return renderedChildren;
}
UIPage.propTypes = Object.assign({}, ComponentWithBodyClass.propTypes, {
  bodyClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  tagName: PropTypes.string.isRequired
});
UIPage.defaultProps = Object.assign({}, ComponentWithBodyClass.defaultProps, {
  tagName: 'div'
});
UIPage.displayName = 'UIPage';